import * as angular from 'angular';
import { virtualExperiencesDashboardComponent } from './virtual-experiences-dashboard.component';
import { topLevelVirtualSearchComponent } from './top-level-virtual-search.component';


export const VirtualSearchModule = angular.module('virtualSearchModule', [])
  .component('topLevelVirtualSearch', topLevelVirtualSearchComponent )
  .component('virtualExperiencesDashboard', virtualExperiencesDashboardComponent )
  .name;
